module.exports = __webpack_public_path__ + "img/i10calcasieubridge_Project Logo.37ebeb2f.png";